/**
 * Data types supported by JSON format
 */
export type JsonType =
  | 'string'
  | 'number'
  | 'object'
  | 'array'
  | 'boolean'
  | 'null';
